import service from '../../utility/service';
import { errorOccurred } from '../../errors/reducer';

const INITIAL_STATE = {
  fetching: false,
  users: undefined
};

const types = {
  FETCHING_USERS: 'orb/admin/users/FETCHING_USERS',
  RECEIVED_USERS: 'orb/admin/users/RECEVIED_USERS'
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.FETCHING_USERS:
      return Object.assign({}, state, {
        fetching: true
      });
    case types.RECEIVED_USERS:
      return Object.assign({}, state, {
        fetching: false,
        users: action.users
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;

function fetchingUsers() {
  return { type: types.FETCHING_USERS };
}

function receivedUsers(users) {
  return {
    type: types.RECEIVED_USERS,
    users
  };
}

function shouldFetchUsers(state) {
  return !state.fetching && !state.users;
}

export function fetchUsersIfNeeded() {
  return (dispatch, getState) => {
    const state = getState().admin.users;
    if (shouldFetchUsers(state)) {
      dispatch(fetchingUsers());

      return service.get('/Admin/Users').then((response) => {
        dispatch(receivedUsers(response.data));
      }).catch((err) => {
        dispatch(errorOccurred(err, 'Getting users'));
        dispatch(receivedUsers([]));
      });
    }
    // Nothing to wait for
    return Promise.resolve();
  };
}



// WEBPACK FOOTER //
// ./src/admin/users/reducer.js